import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { powerReceivingGuard } from './core/guards/power-receiving.guard';
import { ShellTitleResolver } from './core/resolvers/shell.resolver';
import { ApplyTitleResolver } from './core/resolvers/apply.resolver';
import { ApplicationFormTitleResolver } from './core/resolvers/application-form.resolver';
import { ApplicationSubmittedTitleResolver } from './core/resolvers/application-submitted.resolver';
import { LoginTitleResolver } from './core/resolvers/login.resolver';
import { CuratedMatchesTitleResolver } from './core/resolvers/curated-matches.resolver';
import { ChatsTitleResolver } from './core/resolvers/chats.resolver';
import { ChatDetailTitleResolver } from './core/resolvers/chat-detail.resolver';
import { ChatConnectionResolver } from './core/resolvers/chat-connection.resolver';
import { ProfileTitleResolver } from './core/resolvers/profile.resolver';
import { AdminReviewTitleResolver } from './core/resolvers/admin-review.resolver';
import { MatchRequestTitleResolver } from './core/resolvers/match-request.resolver';

export const routes: Routes = [
  // Public
  {
    path: 'apply',
    loadComponent: () => import('./pages/apply-landing/apply-landing.page').then(m => m.ApplyLandingPage),
    resolve: { title: ApplyTitleResolver },
    data: { title: '' },
  },
  {
    path: 'apply/form',
    loadComponent: () => import('./pages/application-form/application-form.page').then(m => m.ApplicationFormPage),
    resolve: { title: ApplicationFormTitleResolver },
    data: { title: '' },
  },
  {
    path: 'apply/submitted',
    loadComponent: () => import('./pages/application-submitted/application-submitted.page').then(m => m.ApplicationSubmittedPage),
    resolve: { title: ApplicationSubmittedTitleResolver },
    data: { title: '' },
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
    resolve: { title: LoginTitleResolver },
    data: { title: '' },
  },

  // App Shell (authenticated)
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./shell/shell.component').then(m => m.AppShellComponent),
    resolve: { title: ShellTitleResolver },
    data: { title: '' },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'curated-matches' },
      {
        path: 'curated-matches',
        loadComponent: () => import('./pages/curated-matches/curated-matches.page').then(m => m.CuratedMatchesPage),
        resolve: { title: CuratedMatchesTitleResolver },
        data: { title: '' },
      },
      {
        path: 'chats',
        loadComponent: () => import('./pages/chats/chats.page').then(m => m.ChatsPage),
        resolve: { title: ChatsTitleResolver, chatConnection: ChatConnectionResolver },
        data: { title: '' },
      },
      {
        path: 'chats/:chatId',
        loadComponent: () => import('./pages/chat-detail/chat-detail.page').then(m => m.ChatDetailPage),
        resolve: { metadata: ChatDetailTitleResolver, chatConnection: ChatConnectionResolver },
        data: { title: '' },
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage),
        resolve: { title: ProfileTitleResolver },
        data: { title: '' },
      },
      {
        path: 'match-request/:partnerId',
        canActivate: [powerReceivingGuard],
        loadComponent: () => import('./pages/match-request/match-request.page').then(m => m.MatchRequestPage),
        resolve: { title: MatchRequestTitleResolver },
        data: { title: '' },
      },
      { path: 'create-post', redirectTo: 'profile' },
      {
        path: 'admin/review',
        canActivate: [adminGuard],
        loadComponent: () => import('./pages/admin-review/admin-review.page').then(m => m.AdminReviewPage),
        resolve: { title: AdminReviewTitleResolver },
        data: { title: '' },
      },
    ],
  },

  // Fallback
  { path: '', pathMatch: 'full', redirectTo: 'apply' },
  { path: '**', redirectTo: 'apply' },
];
